import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { Container, Row, Col, Button } from "reactstrap";
import classnames from "classnames";
import moment from "moment"
import Countdown from "react-countdown";
import _ from "lodash";
import styled from 'styled-components';
import ReactLoading from "react-loading";

import SingleThumbnail from "../../PageProductDetails/Detail/Thumbnails/SingleThumbnail";
import ShareSocialSection from "../../PageProductDetails/Detail/ShareSocialContainer";
import NoteSection from "../../PageCheckout/Detail/Notes";
import SneakerInfoSection from "../../PageCheckout/Detail/SneakerInfoContainer";
import InvoiceSection from "./Invoice";
import Footer from "../../PageProductDetails/Detail/Footer";
import Thumbnails from "../../PageProductDetails/Detail/Thumbnails";
import SmallThumbnails from "../../PageProductDetails/Detail/Thumbnails/SmallThumbnails";
import ShareSocialContainer from "../../PageProductDetails/Detail/ShareSocialContainer";
import Breadcrumbs from "../../PageProductDetails/Detail/Breadcrumbs";
import Notes from "../../PageProductDetails/Detail/Notes";

import BankTransferSection from './Invoice/BankTransfer';
import XenditSection from './Invoice/Xendit';
import MidtransSection from './Invoice/Midtrans';
import KredivoSection from './Invoice/Kredivo';
import AkulakuSection from './Invoice/Akulaku';
import AtomeSection from './Invoice/Atome';

import { getCacheImage } from "../../../config";
import Analytics from "../../../services/Analytics";

/* IMPORT UTILS */
import { convertToRupiah, emptyImage, getCloudImageUrl, formatCurrency } from "../../../utils";
import {
  dustBag,
  boxHandbag,
  boxCondition,
  detailCondition,
  defectCondition,
  handbagCondition,
  sneakersCondition,
  accessoriesCondition,
  detailHandbagCondition
} from "../../../utils/Helpers"

/* IMPORT IMAGE */
import CloseButton from "../../../images/bag-delete.png";
import PlusButton from "../../../images/bag-plus.png";
import MinusButton from "../../../images/minus.png";
import PinAddress from "../../../images/pin-address.png";
import ContinueArrow from "../../../images/shopping-cart-continue.png";
import BackArrow from "../../../images/shopping-cart-back.png";
import ArrowsNext from "../../../images/arrowsNext.png";
import CircleBack from "../../../images/circle-back.png";
import StopWatch from "../../../images/stopwatch.png";
import Copy from "../../../images/copyIcon.png"
import KickCreditSuccess from "../../../images/kick-credit-payment-success.jpg"

const LoadingWrapper = styled.div`
  height: 100%;
  margin-bottom: ${(props) => (props.noWrapper ? "32px" : "0")};
  display: flex;
  justify-content: center;
  align-items: center;
  .spinner-border{
    width: 4em;
    height: 4em;
  }
`

const renderer = ({ days, hours, minutes, seconds, completed, ...props }) => {
  const newHours = days * 24 + hours;
  return (
    <p>
      {newHours === 0 ? "00 " : newHours}:{minutes === 0 ? " 00 " : minutes}:{seconds === 0 ? " 00" : seconds}
    </p>
  );
};

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    ></div>
  );
};

const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    ></div>
  );
};
const previewSettings = {
  arrows: true,
  autoplay: true,
  infinite: true,
  // fade:true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  lazyLoad: true,
  dots: false,
  swipe: false,
};
const thumbnailSettings = {
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  autoplay: false,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
};

export default class Detail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
      modalVisible: false,
    };
    this.changeImage = this.changeImage.bind(this);
    this._handleGoto = this._handleGoto.bind(this);
    this.handleModalAlert = this.handleModalAlert.bind(this);
  }

  componentDidMount() {
    const { product, payment, sell } = this.props;
    const user_sell_id = sell ? sell.id : null;
    const seller_id = sell ? sell.user_id : null;

    Analytics.recordPurchase(
      product.display_name,
      product.product.category.name,
      product.SKU,
      "product",
      payment.total_amount,
      this.props.userCurrency.currency || "IDR",
      user_sell_id,
      seller_id,
      payment.invoice_number,
      product.id
    );
  }

  changeImage(currentIndex) {
    this.setState({ currentIndex: currentIndex });
  }

  _handleGoto(e, currentIndex) {
    e.preventDefault();
    this.setState({ currentIndex: currentIndex });
  }

  handleModalAlert() {
    this.setState({
      modalVisible: !this.state.modalVisible,
    });
  }

  handlePaymentSection() {
    const {
      product
    } = this.props

    const orderDetailsData = {
      payment: this.props.payment,
      product: this.props.product,
      addonProduct: this.props.addOnProduct,
      sell: this.props.sell
    }

    switch (this.props.type) {
      case "kickwallet":
      case "kick_point":
      case "full_wallet":
      case "transfer":
        return <BankTransferSection
          data={this.props.payment.account_banks}
          payment={this.props.payment}
          onClick={this.props.onActionClick}
          expire={this.props.payment.expiry}
          product={product}
          orderDetailsData={orderDetailsData}
        />

      case "sprint_asia":
      case "xendit":
        return <XenditSection
          userCurrency={this.props.userCurrency}
          data={this.props.payment}
          onClick={this.props.onActionClick}
          expire={this.props.payment.expiry}
          product={product}
          orderDetailsData={orderDetailsData}
        />

      case "gopay":
      case "midtrans":
        return <MidtransSection
          userCurrency={this.props.userCurrency}
          trxTkn={this.props.trxTkn}
          data={this.props.payment}
          onClick={this.props.onActionClick}
          expire={this.props.payment.expiry}
          product={product}
          orderDetailsData={orderDetailsData}
        />

      case "kredivo":
        return <KredivoSection
          data={this.props.payment}
          onClick={this.props.onActionClick}
          expire={this.props.payment.expiry}
          product={product}
          orderDetailsData={orderDetailsData}
        />

      case "akulaku":
        return <AkulakuSection
          data={this.props.payment}
          onClick={this.props.onActionClick}
          expire={this.props.payment.expiry}
          product={product}
          orderDetailsData={orderDetailsData}
        />

      case "atome":
        return <AtomeSection
          data={this.props.payment}
          onClick={this.props.onActionClick}
          expire={this.props.payment.expiry}
          product={product}
          orderDetailsData={orderDetailsData}
        />

      default:
        return null
    }
  }

  getSelectedPayment(paymentMethod, bankCode) {
    switch (paymentMethod) {
      case 'virtual_account': return bankCode ? `${bankCode} - Virtual Account` : 'Virtual Account';
      case 'credit_card': return 'Credit Card';
      case 'kredivo': return 'Kredivo';
      case 'full_wallet': return 'Kick Credit';
      default: return 'Bank Transfer';
    }
  }

  _handbagCondition(sneaker_condition) {
    switch (sneaker_condition) {
      case "BARU":
        return "BRAND NEW";
      case "PRISTINE":
        return "PRISTINE";
      case "GOOD":
        return "GOOD";
      case "WELL_USED":
        return "WELL USED";
      case "LIKE_NEW":
        return "LIKE NEW";
      case "VINTAGE":
        return "VINTAGE";
      default:
        return "";
    }
  }

  handleProductConditions = () => {
    const {
      missing_accessories,
      sneakers_defect,
      sneakers_condition,
      yellowing,
      display_item,
      defects,
      box_condition,
      hide_box_info,
      sneaker_condition
    } = this.props.sell || {}

    const {
      product
    } = this.props.product

    const { category = {} } = product || {}

    const uniqueDefects = _.uniqBy(defects, "name");
    const dustBagCondition = uniqueDefects
      ? uniqueDefects.find(a => a.name === "DUST_BAG")
      : {};
    const boxConditions = uniqueDefects
      ? uniqueDefects.find(a => a.name === "BOX")
      : {};
    const boxConditionNew = hide_box_info
      ? null
      : boxCondition(box_condition);
    const productDefects = uniqueDefects.length > 0 ? uniqueDefects.filter(item => item.value).map(item => item.display_name) : [];

    const generalConditions = [
      sneakersCondition(sneakers_condition),
      boxConditionNew,
      accessoriesCondition(missing_accessories),
      yellowing ? "Yellowing" : null,
      sneakers_defect ? "Defect" : null,
      display_item ? "Display Item" : null
    ];
    const ProductConditions = [...generalConditions, ...productDefects];
    const productConditionDetail = ProductConditions
      .filter(item => item !== null)
      .map(item => item)
      .join(", ");

    const luxuryDetailArr = [
      sneakersCondition(sneakers_condition),
      accessoriesCondition(missing_accessories),
      dustBag(dustBagCondition && dustBagCondition.value),
      boxHandbag(boxConditions),
      sneakers_defect ? handbagCondition(uniqueDefects) : ""
    ];
    const luxuryDetail = luxuryDetailArr
      .filter(item => item !== "" && item !== "Missing Box")
      .map(item => item)
      .join(", ");

    return category.name === "handbags" ? luxuryDetail : productConditionDetail
  };

  renderSize = () => {
    const {
      product,
      display_name
    } = this.props.product

    const {
      size,
      sneakers_condition
    } = this.props.sell

    const { category = {} } = product || {}

    const isVilla = () => {
      const DETERMINED_KEYWORD = "FILA";

      if (!display_name) return;

      return display_name
        .toLowerCase()
        .includes(DETERMINED_KEYWORD.toLowerCase());
    };

    const isSneakers = isVilla() && category === "sneakers";
    const isApparels = isVilla() && category === "apparels";
    const sneakerSize = !size.cm ? "" : size.cm;
    const apparelSize = !size.US ? "" : `US ${size.US}`;

    const isHandbag = this._handbagCondition(sneakers_condition)

    const sizeForDesc = (() => {
      if (category.name === "handbags" || category.name === "lifestyles") {
        return apparelSize === "All Size"
          ? `${isHandbag && isHandbag.toLowerCase()} ${apparelSize}`
          : isHandbag ? `${isHandbag && isHandbag.toLowerCase()}` : apparelSize;
      } else if (isSneakers) {
        return sneakerSize;
      } else {
        return apparelSize;
      }
    })();

    return sizeForDesc
  }

  render() {
    const { isLoading } = this.props
    const { product_variant_images, display_name, product = {} } = this.props.product;
    const haveImages =
      product_variant_images !== undefined
        ? product_variant_images.length > 0
        : false;

    const { category = {} } = product || {}

    const { userCurrency: dataUserCurrency } = this.props

    const {
      offer_amount = "",
      administration_fee = "",
      discount = "",
      subsidy_price = "",
      ka_courier_price = "",
      actual_total_amount = "",
      status,
      total_amount = "",
      ka_courier_discount = "",
      total_adjusted_amount = "",
      scredit_amount = "",
      lbalance_amount = "",
      wallet_amount = "",
      payment_method
    } = this.props.payment || {}

    const addonProductArr = this.props?.payment?.ka_courier_option.split(" + ")

    const filteredProductAddOn = this.props.addOnProduct.length > 0 && this.props.addOnProduct.filter(addon => addonProductArr.includes(addon.name))

    const isOnlyKickPoint = payment_method === "kick_point";
    const userCurrency = isOnlyKickPoint? {
      ...dataUserCurrency,
      currency: "KP"
    } : dataUserCurrency;
    
    return (
      <>
        <Container fluid id="invoice-tpo-page">
          <Row className="shopping-cart-page-second-wrapper">
            <Col className="left-bag-content">
              {isLoading ?
                <LoadingWrapper>
                  <ReactLoading type={"spin"} height={50} width={50} color={"#159953"} />
                </LoadingWrapper>
                :
                <div className="scroll-wrapper">
                  <Row className="left-bag-top-section-shopping-bag">
                    <Row className="shopping-bag-title-wrapper">
                      <h3 className="left-bag-top-section-shopping-bag-title">
                        Order Details
                      </h3>
                    </Row>
                    <Row className="shopping-bag-item-card-list-wrapper">
                      {/* MAIN PRODUCT ITEM */}
                      <Row className="shopping-bag-item-card">
                        <Row className="shopping-bag-item-wrapper">
                          <Col className="shopping-bag-item-card-image-wrapper">
                            {haveImages ? <KickImage
                              src={getCloudImageUrl(product_variant_images[0].URL)}
                              alt="..."
                            /> : <KickImage src={emptyImage(product.category.name)} alt="..." />
                            }
                          </Col>
                          <Col className="shopping-bag-item-card-description-wrapper">
                            <div className="desc-wrapper">
                              <p>
                                {display_name}
                              </p>
                              <p>
                                {this.renderSize()} / {this.handleProductConditions()}
                              </p>
                            </div>
                            <div className="price-quantity-wrapper">
                              <p>
                                {formatCurrency(
                                  parseInt(offer_amount),
                                  userCurrency.ratio,
                                  userCurrency.currency,
                                )}
                              </p>
                              <p>Qty 1</p>
                            </div>
                          </Col>
                        </Row>
                      </Row>

                      {/* ADD ONS ITEM */}
                      {filteredProductAddOn.length > 0 &&
                        filteredProductAddOn.map(addon => {
                          const { img_url, display_name, description, price } = addon;
                          return (
                            <Row className="shopping-bag-item-card">
                              <Row className="shopping-bag-item-wrapper">
                                <Col className="shopping-bag-item-card-image-wrapper">
                                  {img_url ? (
                                    <KickImage src={img_url} alt="..." />
                                  ) : (
                                    <KickImage src={emptyImage("sneakers")} alt="..." />
                                  )}
                                </Col>
                                <Col className="shopping-bag-item-card-description-wrapper">
                                  <div
                                    className="desc-wrapper">
                                    <p>{display_name}</p>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: description,
                                      }} />
                                  </div>
                                  <div className="price-quantity-wrapper">
                                    <p>{formatCurrency(parseInt(price), userCurrency.ratio, userCurrency.currency)}</p>
                                    <p>Qty 1</p>
                                  </div>
                                </Col>
                              </Row>
                            </Row>
                          )
                        })
                      }
                    </Row>
                  </Row>
                  <Row className="left-bag-bottom-section-extra-item">
                    <Row className="right-bag-content-section-wrapper right-bag-summary-wrapper">
                      <Row className="right-bag-content-summary-row">
                        <p>Payment Summary</p>
                      </Row>
                      <Row className="right-bag-content-summary-row">
                        <p>Product Price</p>
                        <p>{formatCurrency(parseInt(offer_amount), userCurrency.ratio, userCurrency.currency)}</p>
                      </Row>
                      {parseInt(administration_fee) > 0 && <Row className="layanan-price right-bag-content-summary-row">
                        <p>Administration Fee</p>
                        <p>{formatCurrency(parseInt(administration_fee), userCurrency.ratio, userCurrency.currency)}</p>
                      </Row>}
                      {parseInt(ka_courier_price) > 0 && <Row className="shipping-fee right-bag-content-summary-row">
                        <p>Shipping &#38; Handling</p>
                        <p>{formatCurrency(parseInt(ka_courier_price), userCurrency.ratio, userCurrency.currency)}</p>
                      </Row>}
                      {parseInt(discount) > 0 && <Row className="discount right-bag-content-summary-row">
                        <p>Voucher Code</p>
                        <p>{formatCurrency(parseInt(discount), userCurrency.ratio, userCurrency.currency)}</p>
                      </Row>}
                      {parseInt(subsidy_price) > 0 && <Row className="subsidy-price right-bag-content-summary-row">
                        <p>
                          Discount &#40;<span>Automatically applied</span>&#41;
                        </p>
                        <p>{formatCurrency(parseInt(subsidy_price), userCurrency.ratio, userCurrency.currency)}</p>
                      </Row>}
                      {parseInt(ka_courier_discount) > 0 && <Row className="total-addon-price right-bag-content-summary-row">
                        <p>Promo Product</p>
                        <p>{formatCurrency(parseInt(ka_courier_discount), userCurrency.ratio, userCurrency.currency)}</p>
                      </Row>}
                      {wallet_amount && <Row className="shipping-fee credit-usage right-bag-content-summary-row">
                        <p>Kick Credit Usage</p>
                        <p>- {formatCurrency(parseInt(wallet_amount), userCurrency.ratio, userCurrency.currency)}</p>
                      </Row>}
                      {scredit_amount && <Row className="shipping-fee credit-usage right-bag-content-summary-row">
                        <p>Seller Credit Usage</p>
                        <p>- {formatCurrency(parseInt(scredit_amount), userCurrency.ratio, userCurrency.currency)}</p>
                      </Row>}
                      {lbalance_amount && <Row className="shipping-fee kick-points right-bag-content-summary-row">
                        <p>Kick Points Usage</p>
                        <p>- {formatCurrency(parseInt(lbalance_amount), userCurrency.ratio, userCurrency.currency)}</p>
                      </Row>}
                      <Row className="total-price right-bag-content-summary-row">
                        <p>Amount to be paid</p>
                        <p>{formatCurrency(parseInt(total_adjusted_amount), userCurrency.ratio, userCurrency.currency)}</p>
                      </Row>
                    </Row>
                  </Row>
                </div>
              }

            </Col>
            <Col className="right-bag-content">
              {/* WAITING PAYMENT 2 */}
              {isLoading ?
                <LoadingWrapper>
                  <ReactLoading type={"spin"} height={50} width={50} color={"#159953"} />
                </LoadingWrapper>
                :
                this.handlePaymentSection()
              }
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}